<template>
  <div>
    <m-tabbar></m-tabbar>
    <div class="manage-style">
      <div v-if="!noData" class="analysisOnly">
        <div class="secondBox">
          <div class="rightCake">
            <highcharts :options="subjectTime" ref="highcharts"></highcharts>
          </div>
          <div class="leftTable">
            <p>问卷满意度调查情况</p>
            <div class="tableUl flexSh">
              <p v-for="(item, index) in columns" :key="index">
                {{ item.title }}
              </p>
            </div>
            <div class="tabHeight flexSh">
              <div
                class="tableDetail"
                v-for="(item, index) in tableList"
                :key="index"
              >
                <div>
                  <p>{{ item.userId }}</p>
                  <p>{{ item.userName }}</p>
                  <p>{{ item.className }}</p>
                  <p>
                    {{
                      item.opinion == '0'
                        ? '满意'
                        : item.opinion == '1'
                        ? '一般'
                        : item.opinion == '2'
                        ? '不满意'
                        : item.opinion == '3'
                        ? '未提交'
                        : ''
                    }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="noData" class="noData" style="margin-top:100px;">
        <p>
          <img src="../../assets/images/noData.png" alt />
        </p>
      </div>
      <!-- 刷新 -->
      <div
        v-if="loadingList"
        style="position:fixed;margin-left:40%;top:55%;z-index:99;"
      >
        <a-spin size="large" />
      </div>
    </div>
  </div>
</template>

<script>
import mTabbar from '../../../src/components/headTable'
import moment from 'moment'
export default {
  data() {
    return {
      noData: false,
      loadingList: false,
      moment,
      columns: [
        { title: 'ID' },
        { title: '姓名' },
        { title: '班级' },
        { title: '选择内容' },
      ],
      tableList: [],
      subjectTime: {},
      timeArr: [],
    }
  },
  beforeCreate() {
    this.form = this.$form.createForm(this)
  },
  methods: {
    getread() {
      this.$http
        .get(
          'https://console.learnonly.com/service/system/app/learnonlyos/getUserOpinion'
        )
        .then((res) => {
          console.log('问卷', res)
          this.tableList = res.data.data
          // 各科用时饼图
          var _this = this
          var timeData = res.data.data
          this.timeArr = []
          let arr0 = []
          let arr1 = []
          let arr2 = []
          let arr3 = []
          let arr = timeData.filter((item) => {
            if (item.opinion == 0) {
              arr0.push(item)
              this.timeArr[0] = arr0
            } else if (item.opinion == 1) {
              arr1.push(item)
              this.timeArr[1] = arr1
            } else if (item.opinion == 2) {
              arr2.push(item)
              this.timeArr[2] = arr2
            } else if (item.opinion == 3) {
              arr3.push(item)
              this.timeArr[3] = arr3
            }
          })
          console.log(arr)
          var arrData = []
          arrData.push(
            { name: '满意', y: this.timeArr[0].length },
            { name: '一般', y: this.timeArr[1].length },
            { name: '不满意', y: this.timeArr[2].length },
            { name: '未提交', y: this.timeArr[3].length }
          )
          this.subjectTime = {
            chart: {
              plotBackgroundColor: null,
              plotBorderWidth: null,
              plotShadow: false,
              type: 'pie',
            },
            title: {
              text: '问卷满意度分布',
              style: {
                color: 'rgba(255, 255, 255, 0.7)',
              },
            },
            credits: {
              enabled: false, //不显示LOGO
            },
            tooltip: {
              pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>',
            },
            plotOptions: {
              pie: {
                allowPointSelect: true,
                cursor: 'pointer',
                dataLabels: {
                  enabled: false,
                },
                showInLegend: true,
                events: {
                  click: function(e) {
                    _this.pieClick(e.point)
                  },
                },
              },
            },
            series: [
              {
                name: '',
                colorByPoint: true,
                data: arrData,
              },
            ],
          }
        })
    },
    pieClick(item) {
      item.name == '满意'
        ? (this.tableList = this.timeArr[0])
        : item.name == '一般'
        ? (this.tableList = this.timeArr[1])
        : item.name == '不满意'
        ? (this.tableList = this.timeArr[2])
        : item.name == '未提交'
        ? (this.tableList = this.timeArr[3])
        : ''
    },
  },
  components: {
    mTabbar,
  },
  filters: {
    // 保留两位小数去0
    parseFloat(num) {
      if (num == undefined) {
        return '0'
      } else {
        var val = parseFloat(num).toFixed(2)
        return parseFloat(val)
      }
    },
    parseFloatMax(num) {
      if (num == undefined) {
        return '0'
      } else {
        var val = parseFloat(num).toFixed(2)
        return val > 100 ? 100 : parseFloat(val)
      }
    },
    ms2min(ms) {
      if (ms) {
        var min = Math.floor((ms / 1000 / 60) << 0)
        var sec = Math.floor((ms / 1000) % 60)
        return min + '分' + sec + '秒'
      } else {
        return '/'
      }
    },
  },
  mounted() {
    this.getread()
  },
}
</script>

<style lang="scss">
@import '~@/assets/css/theme.scss';
</style>

<style scoped>
/* @import url('https://m1.bdp.cn/static/pkg/shareApp-bundle_74a0ab6.css'); */
/deep/ p {
  margin: 0;
  padding: 0;
}
/deep/ .ant-form-inline .ant-form-item {
  display: inline-block;
  margin: 0 16px 20px 10px;
}

/* 2 */
.secondBox {
  height: 100vh;
  background: #19192c;
  padding: 15px 15px 0 15px;
  overflow: hidden;
}
.secondBox .leftTable {
  float: left;
  width: 65%;
  height: 530px;
  background: #24263e;
  padding: 0 15px;
}
.secondBox p {
  color: rgba(255, 255, 255, 0.7);
  padding: 10px 0;
}
.secondBox .rightCake {
  float: left;
  width: 35%;
  height: 530px;
  background: #24263e;
  padding-top: 10px;
  border-right: 10px solid #19192c;
}
/deep/.highcharts-legend-item > text {
  fill: rgba(255, 255, 255, 0.7) !important;
}
.tableUl {
  display: flex;
  background: #191a2c;
}
.tableUl p {
  flex: 1;
  color: rgba(255, 255, 255, 0.7);
  font-size: 13px;
  line-height: 36px;
  padding: 0 5px;
  border-right: 1px solid #24263e;
  text-align: center;
  overflow: hidden;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.flexSh p:first-child {
  flex: 0.5;
  overflow: hidden;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.tabHeight {
  height: 430px;
  overflow: auto;
}
.flexSh .tableDetail p:first-child {
  flex: 0.5;
}
/* 滚动条 */
::-webkit-scrollbar {
  width: 0;
}
.tableDetail div {
  display: flex;
  border-bottom: 1px solid #24263e;
  background: #313449;
}
.tableDetail p {
  flex: 1;
  font-size: 13px;
  line-height: 32px;
  padding: 0 5px;
  border-right: 1px solid #24263e;
  text-align: center;
  color: rgb(225, 225, 225, 0.8);
}
/* 滚动条 */
::-webkit-scrollbar {
  width: 0;
}
/* x轴颜色 */
/deep/.highcharts-drilldown-axis-label {
  fill: rgba(255, 255, 255, 0.7) !important;
}
/* 网格线 */
/deep/.highcharts-grid-line {
  fill: none;
  stroke: rgba(255, 255, 255, 0.06);
}
/deep/.highcharts-axis-line {
  fill: none;
  stroke: rgba(255, 255, 255, 0.5);
}
</style>
